// import config from 'config';
import { apiConstants } from "../_constants";
import { authHeader, handleResponse } from "../_helpers";
export const examService = {

    getQuestionAnswerWithPrevNext,
    getQuestionAnswerWithPrevNextforMockTest,
    getQuestionAnswerWithPrevNextforGrandQuiz,
    mocktestList,
    grandTestList,
    questionList,
    getMockTestAnswerSheet,
    checkExamAttendStatus
};


function getQuestionAnswerWithPrevNext(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getquestionanswerwithprevnext", requestOptions).then(
        handleResponse
    );
}
function getQuestionAnswerWithPrevNextforMockTest(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getquestionanswerwithprevnextformocktest", requestOptions).then(
        handleResponse
    );
}
function getQuestionAnswerWithPrevNextforGrandQuiz(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getquestionanswerwithprevnextforgrandquiz", requestOptions).then(
        handleResponse
    );
}

//getting mocktestlist
function mocktestList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getmocktestlist", requestOptions).then(
        handleResponse
    );
}
function grandTestList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getexamlist", requestOptions).then(
        handleResponse
    );
}

async function questionList(data) {
    const requestOptions = {
        method: "POST",
        headers: await authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getquestionList", requestOptions).then(
        handleResponse
    );
}
async function getMockTestAnswerSheet(data) {
    const requestOptions = {
        method: "POST",
        headers: await authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getmocktestanswersheet", requestOptions).then(
        handleResponse
    );
}
async function checkExamAttendStatus(data) {
    const requestOptions = {
        method: "POST",
        headers: await authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/checkgrandquizattendstatus", requestOptions).then(
        handleResponse
    );
}

